import Modal from '../custom/Modal';
import ModalClose from './ModalClose';
import { useAppTranslation } from '../../i18n';
import Tabs from '../tabs/Tabs';
import { useDispatch } from 'react-redux';
import { ModalEnum, uiActions } from '../../app/slices/ui.slice';

const InfoModal = () => {
	const dispatch = useDispatch();
	const { t } = useAppTranslation();

	const handleOnCloseModal = () => {
		dispatch(uiActions.toggleModal(ModalEnum.INFO_MODAL));
	};

	return (
		<Modal onClose={handleOnCloseModal} ariaLabel={t('footer.help')}>
			<ModalClose onClose={handleOnCloseModal} />
			<Tabs />
		</Modal>
	);
};

export default InfoModal;
